'use strict';

module.exports = {
    language: {
        frca: 'fr-CA'
    },
    site: {
        de: 'Anthropologie-DE',
        eu: 'Anthropologie-EU',
        us: 'Anthropologie'
    }
};
